module.exports = __webpack_public_path__ + "img/month.2db9d810.svg";